export const ActionTypes = {
  LOADING: "RESET_PASSWORD_LINK_LOADING",
  ERROR: "RESET_PASSWORD_LINK_ERROR",
  SUCCESS: "RESET_PASSWORD_LINK_SUCCESS",
};
